export const modalUrlName = 'KS';
